module.exports = __webpack_public_path__ + "assets/webgl/ticket_verso_EN_L0.jpg.253f7c39.webp";